import { connect } from 'react-redux'

import VendorPricingAgreements from '@components/vendor-pricing-agreements/VendorPricingAgreements'

import services from '@services'
import coordinators from '@coordinators'
import { HandleError } from '@coordinators/composed'

import { VendorPricingAgreement } from '@types'

interface State {
  universalVendorPricingAgreements: VendorPricingAgreement[] | null
}

const mapStateToProps = (state: State) => {
  return {
    vendorPricingAgreements: state.universalVendorPricingAgreements,
  }
}

const mapDispatchToProps = () => {
  const { RestService, UIService, VendorPricingAgreementsService } = services
  const {
    GetUniversalVendorPricingAgreements,
    ShowEditVendorPricingAgreement,
  } = coordinators

  const getUniversalVendorPricingAgreements =
    GetUniversalVendorPricingAgreements({
      RestService,
      VendorPricingAgreementsService,
      HandleError,
    })

  const editVendorPricingAgreement = ShowEditVendorPricingAgreement({
    UIService,
    VendorPricingAgreementsService,
  })

  return {
    getUniversalVendorPricingAgreements,
    editVendorPricingAgreement,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VendorPricingAgreements)
